export const I18nRemediation = 'posture';
export const PLATFORM = 'platform';
export const ENVIRONMENTS = 'cloudAccountId';
export const RULESETS = 'rulesetId';
export const savedFiltersComponentName = 'remediationSavedFilters';
